import {
  CommentOutlined,
  GoldOutlined,
  LoginOutlined,
} from '@ant-design/icons';
import { Col, ConfigProvider, Row, Statistic } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import formatRelativeTime from '../../utilities/time/formatRelativeTime';

interface DetailsProps {
  expert: {
    joinedAt: number | null;
    conversationLevel?: number | null;
    totalMentions?: number | null;
  };
}

const Details = function ({ expert }: DetailsProps) {
  const { joinedAt, conversationLevel, totalMentions } = expert;
  const {
    t,
    i18n: { language },
  } = useTranslation();

  return (
    <ConfigProvider
      theme={{
        components: {
          Statistic: {
            titleFontSize: 16,
            contentFontSize: 15,
          },
        },
      }}
    >
      <Row gutter={[16, 16]}>
        {joinedAt && (
          <Col xs={16} md={8}>
            <Statistic
              title={t('pages:::memberSince')}
              value={formatRelativeTime(joinedAt, language)}
              prefix={<LoginOutlined />}
              styles={{ content: { textTransform: 'capitalize' } }}
            />
          </Col>
        )}
        {!!conversationLevel && (
          <Col xs={16} md={8}>
            <Statistic
              title={t('chat:::customersHelped')}
              value={`${conversationLevel}+`}
              prefix={<CommentOutlined />}
            />
          </Col>
        )}
        {!!totalMentions && (
          <Col xs={16} md={8}>
            <Statistic
              title={t('chat:::communityGuuruOpinionsShared')}
              value={`${totalMentions}+`}
              prefix={<GoldOutlined />}
            />
          </Col>
        )}
      </Row>
    </ConfigProvider>
  );
};

export default Details;
